import { render, staticRenderFns } from "./EndTravels.vue?vue&type=template&id=19d300b4&scoped=true&"
import script from "./EndTravels.vue?vue&type=script&lang=js&"
export * from "./EndTravels.vue?vue&type=script&lang=js&"
import style0 from "./EndTravels.vue?vue&type=style&index=0&id=19d300b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d300b4",
  null
  
)

export default component.exports